import {
  RECEIVE_FEED_OWNER_USERS,
  RECEIVE_FEED_OWNER_ROWS,
  FeedOwnerRow
} from "../actions/feedOwnerReport";

interface State {
  users: string[];
  rows: FeedOwnerRow[];
  selectedUser: string | null;
}

const DEFAULT_STATE: State = { users: [], rows: [], selectedUser: null };

const feedOwnerReport = (state: State = DEFAULT_STATE, action: any): State => {
  switch (action.type) {
    case RECEIVE_FEED_OWNER_USERS:
      return { ...state, users: action.users };
    case RECEIVE_FEED_OWNER_ROWS:
      return { ...state, rows: action.rows, selectedUser: action.user };
    default:
      return state;
  }
};

export default feedOwnerReport;
